import dayjs from "dayjs";

export const asnColumns=[
    {
        field:"lineNo",
        headerName:"Line No",
        align:"right",
      },{
        field:"skuCode",
        headerName:"SKU Code",
        align:"left",
        left:180,
        width:200
      },{
        field:"packType",
        headerName:"Pack Type",
        // sortable:false,
        width: 100,
        align:"left"
      },{
        field:"poNumber",
        headerName:"PO Number",
        // sortable:false,
        width: 150,
        align:"left"
      },{
        field:"extPONumber",
        headerName:"ExtPO Number",
        // sortable:false,
        width: 150,
        align:"left"
      },{
        field:"poLineNo",
        headerName:"POLine No",
        // sortable:false,
        align:"right",
        width: 120,
      },{
        field:"mln",
        headerName:"MLN",
        // sortable:false,
        width: 120,
        align:"left"
      },
      {
        field:"qtyExpected",
        headerName:"Qty Expected",
        // sortable:false,
        align:"right",
        width: 120,
      },
      {
        field:"baseUOM",
        headerName:"Base UOM",
        // sortable:false,
        width: 100,
        align:"left"
      },
      {
        field:"manufacturingDate",
        //headerName:"Manufacturing Date",
        headerName:"MFG Date",
        // sortable:false,
        width: 120,
        align:"left",
        valuesGetter: (col) => {
          return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
        },
      },
      {
        field:"expiryDate",
        headerName:"Expiry Date",
        // sortable:false,
        width: 120,
        align:"left",
        valuesGetter: (col) => {
          return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
        },
      },
      {
        field:"vDONo",
        headerName:"DO No",
        // sortable:false,
        width:220,
        align:"left"
      },
      {
        field:"vInvNo",
        headerName:"Inv No",
        // sortable:false,
        width:220,
        align:"left"
      }
]